var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import EmberDataBaseFragment from 'ember-data-model-fragments/fragment';
let UserService = (_dec = attr('boolean'), _dec2 = attr('boolean'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec10 = attr('boolean'), _dec11 = attr('string'), _dec12 = attr('boolean'), _dec13 = attr('string'), _dec14 = attr('date'), _dec15 = attr('string'), _dec16 = attr('number'), _dec17 = attr('string'), _dec18 = attr('string'), _dec19 = attr('string'), _class = class UserService extends EmberDataBaseFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "autoRenew", _descriptor, this);
    _initializerDefineProperty(this, "deleted", _descriptor2, this);
    _initializerDefineProperty(this, "displayName", _descriptor3, this);
    _initializerDefineProperty(this, "domainName", _descriptor4, this);
    _initializerDefineProperty(this, "domainId", _descriptor5, this);
    _initializerDefineProperty(this, "domainCreationDate", _descriptor6, this);
    _initializerDefineProperty(this, "expiresOn", _descriptor7, this);
    _initializerDefineProperty(this, "isExtendable", _descriptor8, this);
    _initializerDefineProperty(this, "isUpgradable", _descriptor9, this);
    _initializerDefineProperty(this, "isVerified", _descriptor10, this);
    _initializerDefineProperty(this, "name", _descriptor11, this);
    _initializerDefineProperty(this, "privacyProtection", _descriptor12, this);
    _initializerDefineProperty(this, "siteId", _descriptor13, this);
    _initializerDefineProperty(this, "startDate", _descriptor14, this);
    _initializerDefineProperty(this, "status", _descriptor15, this);
    _initializerDefineProperty(this, "termLength", _descriptor16, this);
    _initializerDefineProperty(this, "type", _descriptor17, this);
    _initializerDefineProperty(this, "userId", _descriptor18, this);
    _initializerDefineProperty(this, "userServiceId", _descriptor19, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "autoRenew", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "deleted", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "displayName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "domainName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "domainId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "domainCreationDate", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "expiresOn", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isExtendable", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isUpgradable", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isVerified", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "privacyProtection", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "siteId", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "startDate", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "termLength", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "userId", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "userServiceId", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UserService as default };